import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import MissionSection from './components/MissionSection';
import PhilosophySection from './components/PhilosophySection';
import CreedSection from './components/CreedSection';
import CrossPromotionalSection from './components/CrossPromotionalSection';
import BooksIntroSection from './components/BooksIntroSection';
import StartVideoConsultation from '../../../components/StartVideoConsultation';
import { START_VIDEO_CONSULTATION } from './constants';
import { PageWrapper } from '../../../components/Layouts/PageWrapper';
import JourneySection from './components/JourneySection';
import LivingTruthSection from './components/LivingTruthSection';

const About = () => {
  return (
    <PageWrapper>
      <HeroSection />
      <StorySection />
      <CrossPromotionalSection />
      <BooksIntroSection />
      <JourneySection />
      <PhilosophySection />
      <MissionSection />
      <CreedSection />
      <LivingTruthSection />
      <StartVideoConsultation
        bgImg={START_VIDEO_CONSULTATION.backgroundImage}
        title={START_VIDEO_CONSULTATION.title}
        btnText={START_VIDEO_CONSULTATION.buttonText}
      />
    </PageWrapper>
  );
};

export default About;
